module.exports = __webpack_public_path__ + "static/media/nike.44152e44.svg";